import React, { useState, useRef, useEffect } from 'react';

const CategoryTabs = ({ categories, selectedCategory, onCategoryChange, language }) => {
  const [scrollPosition, setScrollPosition] = useState(0);
  const [isDragging, setIsDragging] = useState(false);
  const [startX, setStartX] = useState(0);
  const [scrollLeft, setScrollLeft] = useState(0);
  const tabsContainerRef = useRef(null);

  const handleScroll = () => {
    if (tabsContainerRef.current) {
      setScrollPosition(tabsContainerRef.current.scrollLeft);
    }
  };

  useEffect(() => {
    const container = tabsContainerRef.current;
    if (container) {
      container.addEventListener('scroll', handleScroll);
      return () => container.removeEventListener('scroll', handleScroll);
    }
  }, []);

  const scrollLeftButton = () => {
    if (tabsContainerRef.current) {
      const container = tabsContainerRef.current;
      const newPosition = Math.max(scrollPosition - 200, 0);
      container.scrollTo({ left: newPosition, behavior: 'smooth' });
    }
  };

  const scrollRightButton = () => {
    if (tabsContainerRef.current) {
      const container = tabsContainerRef.current;
      const newPosition = Math.min(
        scrollPosition + 200, 
        container.scrollWidth - container.clientWidth
      );
      container.scrollTo({ left: newPosition, behavior: 'smooth' });
    }
  };

  const handleMouseDown = (e) => {
    if (tabsContainerRef.current) {
      setIsDragging(true);
      setStartX(e.pageX - tabsContainerRef.current.offsetLeft);
      setScrollLeft(tabsContainerRef.current.scrollLeft);
    }
  };

  const handleMouseUp = () => {
    setIsDragging(false);
  };

  const handleMouseLeave = () => {
    setIsDragging(false);
  };

  const handleMouseMove = (e) => {
    if (!isDragging) return;
    e.preventDefault();
    if (tabsContainerRef.current) {
      const x = e.pageX - tabsContainerRef.current.offsetLeft;
      const walk = (x - startX) * 2; // Adjust this value to control scroll speed
      tabsContainerRef.current.scrollLeft = scrollLeft - walk;
    }
  };

  return (
    <div className="category-tabs">
      <button className="carousel-button prev" onClick={scrollLeftButton}>
        <span>&#10094;</span>
      </button>
      <div 
        className="tabs-container" 
        ref={tabsContainerRef}
        onMouseDown={handleMouseDown}
        onMouseUp={handleMouseUp}
        onMouseLeave={handleMouseLeave}
        onMouseMove={handleMouseMove}
        style={{ overflowX: 'scroll', scrollbarWidth: 'none', msOverflowStyle: 'none' }}
      >
        <div className="tabs-content">
          {categories.map((category) => (
            <div 
              key={category.id}
              className={`category-tab ${selectedCategory === category.id ? 'active' : ''}`}
              onClick={() => onCategoryChange(category.id)}
            >
              {category.image_link && (
                <img 
                  src={category.image_link} 
                  alt={category[`${language}_name`]} 
                  className="category-icon"
                />
              )}
              <span className="category-name">
                {category[`${language}_name`]}
              </span>
            </div>
          ))}
        </div>
      </div>
      <button className="carousel-button next" onClick={scrollRightButton}>
        <span>&#10095;</span>
      </button>
    </div>
  );
};

export default CategoryTabs;